module.exports = __webpack_public_path__ + "onboarding-communitysteps.a1c361a0401543e867f7e6cea476c73c.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/projects/empty/onboarding-communitysteps.svg
// module id = 4465246367317358
// module chunks = 1